import React from 'react';
import { motion } from 'framer-motion';
import { SocialIconsRow } from './SocialIcons';

const Contact = () => {
  return (
    <section id="contact" className="scroll-mt-24 border-t border-lotus-petal bg-white px-6 py-20 lg:px-8 lg:py-28">
      <motion.div 
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.8 }}
        className="mx-auto max-w-3xl text-center"
      >
        <span className="mb-4 block text-xs font-medium uppercase tracking-[0.3em] text-lotus-deep/80">
          Let's Create a Healthier Future
        </span>
        <h2 className="font-serif text-3xl leading-tight text-lotus-ink sm:text-4xl lg:text-5xl">
          Together
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-lotus-ink/60">
          Whether you are an individual seeking personal well-being or an organization looking to cultivate a healthier workplace, Lotus Prana is here to support your journey.
        </p>

        <div className="mt-10">
          <motion.a
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            href="mailto:lotusprana1@gmail.com"
            className="inline-block border-b-2 border-lotus-deep/40 pb-2 font-serif text-2xl text-lotus-deep transition-colors hover:border-lotus-deep hover:text-lotus-deep/90 sm:text-3xl"
          >
            lotusprana1@gmail.com
          </motion.a>
        </div>

        {/* Social Media Links */}
        <div className="mt-10 flex flex-col items-center gap-3">
          <span className="text-xs uppercase tracking-widest text-lotus-ink/50 font-semibold">
            Connect With Us
          </span>
          <div className="pt-1">
            <SocialIconsRow containerClass="flex items-center justify-center gap-4" />
          </div>
        </div>

        <p className="mt-10 font-serif text-lg italic text-lotus-deep/70">
          Transforming Lives. Empowering Workplaces.
        </p>
      </motion.div>
    </section>
  );
};

export default Contact;


